import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ImageShape",
  "use": "svg-icon-ImageShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-ImageShape\"><circle class=\"st0\" cx=\"8\" cy=\"8\" r=\"1.5\" /><path class=\"st0\" d=\"M24 15.3V5.7C24 4.2 22.8 3 21.2 3H2.8C1.2 3 0 4.2 0 5.8v12.5C0 19.8 1.2 21 2.8 21h18.5c1.5 0 2.8-1.2 2.8-2.8l-.1-2.9zM2.8 4.5h18.5c.7 0 1.2.6 1.2 1.2v8.1l-5.9-5.9-7.5 7.5-3.8-3.8-3.8 3.8V5.8c0-.7.6-1.3 1.3-1.3zm18.4 15H2.8c-.7 0-1.2-.6-1.2-1.2v-.6l3.8-3.8 3.8 3.8 7.5-7.5 5.9 5.9v2.3c-.1.5-.7 1.1-1.4 1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol